import { VerifiedUserOutlined } from "@mui/icons-material";
import MenuItemMui from "@mui/material/MenuItem";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import timezone from "dayjs/plugin/timezone";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { GridArrowDownwardIcon } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { utc } from "dayjs";
import {
  setPayload,
  setPutPayload,
  setPutPayloadWithParams,
} from "../../services/api";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ApproveJobComponent = ({
  colors,
  isNonMobile,
  id,
  year,
  regDate,
  project,
  institute,
  contactNo,
  email,
  grandTotal,
  paid,
  officers,
  setOpen,
  setMessage,
  setMessageType,
  data,
  loading,
  setLoading,
  labTest,
}) => {
  const [currentRequest, setCurrentRequest] = useState({
    user: "",
    error: false,
  });

  const [currentTest, setCurrentTest] = useState({
    labTest: "",
    error: false,
  });

  const [availableJobCount, setAvailableJobCount] = useState("");

  const [approveDate, setApproveDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  const handleApproveRequest = (e) => {
    if (currentRequest.user === "") {
      setCurrentRequest((pre) => ({
        ...pre,
        error: pre.user === "" ? true : false,
      }));
    } else {
      setCurrentRequest((pre) => ({
        ...pre,
        error: false,
      }));
      setCurrentTest((pre) => ({
        ...pre,
        error: false,
      }));
      apprveSelectedRequestDB();
    }
  };

  const getHowManyJobInHand = async (userId) => {
    setLoading(true);
    await axios
      .get(DATA_SAVE_URL + "/api/v1/labReq/jobsInHand/" + userId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        setAvailableJobCount(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const apprveSelectedRequestDB = async () => {
    setLoading(true);
    setCurrentRequest((pre) => ({
      ...pre,
      user: "",
    }));
    console.log("user ", currentRequest.user);
    console.log("user ", currentTest.labTest);
    console.log("date ", approveDate);

    await setPutPayloadWithParams
      .setPayloadData(`/labReq/${data.id}`, null, {
        userId: currentRequest.user,
        assignDate: approveDate,
      })
      .then(function (response) {
        console.log(response.data);

        setMessage(
          "Job : " +
            data.year +
            "/" +
            data.autoIdByYear +
            " approved successfully..!"
        );
        setMessageType("success");
        setOpen(true);
        setLoading(false);
        setCurrentRequest((pre) => ({
          ...pre,
          user: "",
        }));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSelectUser = (e) => {
    setCurrentRequest((pre) => ({
      ...pre,
      user: e.target.value,
    }));
    // getHowManyJobInHand(e.target.value);
  };
  const handleSelectTest = (e) => {
    setCurrentTest((pre) => ({
      ...pre,
      labTest: e.target.value,
    }));
  };

  return (
    <Accordion color="success">
      <AccordionSummary
        expandIcon={<GridArrowDownwardIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            width: "100%",
            borderRadius: "10px",
            padding: "5px",
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex">
              <Typography variant="h5" marginRight="10px" color="error">
                {year + "/" + String(data.autoIdByYear).padStart(4, "0") + " "}
              </Typography>
              <Typography variant="h5" color={colors.grey[500]}>
                {project}
              </Typography>
            </Box>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          variant="outlined"
          sx={{
            border:
              paid === true
                ? `${colors.greenAccent[500]} solid thin`
                : `red solid thin`,
            width: "100%",
            marginBottom: "6px",
            //   backgroundColor: colors.grey[900],
          }}
        >
          <CardContent style={{ paddingBottom: "2px" }}>
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <Box
                sx={{
                  gridColumn: "span 5",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ width: "100%" }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h3" color="success">
                      Project
                    </Typography>
                    <Typography variant="h3" color="error">
                      Job No :{" "}
                      {year + "/" + String(data.autoIdByYear).padStart(4, "0")}
                    </Typography>
                  </Box>
                  <Typography variant="h3" color={colors.grey[500]}>
                    {project}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Job register date</Typography>
                <Typography variant="h5" color="success">
                  {regDate}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 2",
                }}
              >
                <Typography variant="h5">Institute</Typography>
                <Typography variant="h5" color="success">
                  {institute.instituteName}
                </Typography>
              </Box>

              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Email</Typography>
                <Typography variant="h5" color="success">
                  {email}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                {paid === true ? (
                  <Typography variant="h3" color="success" fontWeight={550}>
                    PAID
                  </Typography>
                ) : (
                  <Typography variant="h3" color="error" fontWeight={550}>
                    UNPAID
                  </Typography>
                )}
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />

              <Box sx={{ gridColumn: "span 5" }}>
                <Typography variant="h4">Job related test(s)</Typography>
                <Box
                  sx={{
                    gridColumn: "span 2",
                    marginBottom: "5px",
                    marginTop: "8px",
                  }}
                  display="flex"
                  flexDirection="column"
                >
                  {labTest?.map((option, index) =>
                    option.assignUser === null ? (
                      <Typography
                        key={index}
                        variant="subtitle1"
                        color="success"
                      >
                        {index + 1}.{" "}
                        {option.labTest.testName +
                          " ( Within " +
                          option.labTest.estimatedTime +
                          " Days froms " +
                          regDate +
                          " )"}
                      </Typography>
                    ) : null
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                gridColumn: "span 2",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {loading ? (
                <CircularProgress
                  sx={{
                    color: colors.greenAccent[500],
                    position: "absolute",
                    zIndex: 10,
                  }}
                />
              ) : (
                ""
              )}
            </Box>
          </CardContent>
          <Divider />
          <CardActions
            sx={{
              margin: 0,
              paddingTop: "0px",
              paddingBottom: "0px",
              justifyContent: "space-between",
            }}
          >
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Date"
                    format="YYYY-MM-DD"
                    sx={{ width: "100%", gridColumn: "span 1" }}
                    timezone="Asia/Colombo"
                    value={
                      approveDate
                        ? dayjs(approveDate).tz("Asia/Colombo", true)
                        : dayjs(new Date()).tz("Asia/Colombo", true)
                    }
                    onChange={(newValue) => {
                      const colomboTime = newValue?.tz("Asia/Colombo", true);
                      setApproveDate(dayjs(colomboTime).format("YYYY-MM-DD"));
                    }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <TextField
                select
                label="Select Technical Officer"
                fullWidth
                size="small"
                defaultValue=""
                value={currentRequest.user}
                error={currentRequest.error}
                onChange={handleSelectUser}
                sx={{
                  marginBottom: "5px",
                  marginTop: "8px",
                  gridColumn: "span 2",
                }}
              >
                {officers?.map((option) => (
                  <MenuItemMui key={option.id} value={option.id}>
                    {option.titles.title +
                      " " +
                      option.firstName +
                      " " +
                      option.lastName}
                  </MenuItemMui>
                ))}
              </TextField>
              <Typography
                sx={{ width: "100%", gridColumn: "span 1" }}
                variant="h5"
                color="warning"
                alignContent="center"
              >
                {availableJobCount}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Button
                type="button"
                loading={loading}
                startIcon={<VerifiedUserOutlined />}
                color="success"
                disabled={paid ? false : true}
                variant="contained"
                onClick={handleApproveRequest}
                sx={{ margin: "10px 0 10px 0" }}
              >
                APPROVE JOB
              </Button>
            </Box>
          </CardActions>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
export default ApproveJobComponent;
